module.exports = __webpack_public_path__ + "static/media/foto2.24cd7eef.png";